export default {
	// mix news list scroll位置回復相關
	storeScrollPosition: 'storeScrollPosition',
	storeRenderedIndex: 'storeRenderedIndex',
	
	// admin
	checkAdminLogin: 'checkAdminLogin',
	beginCheckAdminLogin: 'beginCheckAdminLogin',
	recvCheckAdminLoginResult: 'recvCheckAdminLoginResult',
	recvCheckAdminLoginError: 'recvCheckAdminLoginError',
	setAdminLoginInfo: 'setAdminLoginInfo',
	
	// logout
	logout: 'logout',
	beginAdminLogout: 'beginAdminLogout',
	logoutDone: 'logoutDone',
	showLogoutModal: 'showLogoutModal',
	closeLogoutModal: 'closeLogoutModal',

	// EmptyInvoice
	getEmptyInvoiceCount: 'getEmptyInvoiceCount',
	beginGetEmptyInvoiceCount: 'beginGetEmptyInvoiceCount',
	recvGetEmptyInvoiceCountResult: 'recvGetEmptyInvoiceCountResult',
	recvGetEmptyInvoiceCountError: 'recvGetEmptyInvoiceCountError',

	getEmptyInvoiceList: 'getEmptyInvoiceList',
	beginGetEmptyInvoiceList: 'beginGetEmptyInvoiceList',
	recvGetEmptyInvoiceListResult: 'recvGetEmptyInvoiceListResult',
	recvGetEmptyInvoiceListError: 'recvGetEmptyInvoiceListError',

	delEmptyInvoice: 'delEmptyInvoice',
	beginDelEmptyInvoice: 'beginDelEmptyInvoice',
	recvDelEmptyInvoiceResult: 'recvDelEmptyInvoiceResult',
	recvDelEmptyInvoiceError: 'recvDelEmptyInvoiceError',

	addEmptyInvoice: 'addEmptyInvoice',
	beginAddEmptyInvoice: 'beginAddEmptyInvoice',
	recvAddEmptyInvoiceResult: 'recvAddEmptyInvoiceResult',
	recvAddEmptyInvoiceError: 'recvAddEmptyInvoiceError',	
	finishGetEmptyInvoiceYearmonthList: 'finishGetEmptyInvoiceYearmonthList',

	// Order Invoice
	getOrderInvoiceInfo: 'getOrderInvoiceInfo',
	beginGetOrderInvoiceInfo: 'beginGetOrderInvoiceInfo',
	recvGetOrderInvoiceInfoResult: 'recvGetOrderInvoiceInfoResult',
	recvGetOrderInvoiceInfoError: 'recvGetOrderInvoiceInfoError',

	// Invoice
	getInvoiceInfo: 'getInvoiceInfo',
	beginGetInvoiceInfo: 'beginGetInvoiceInfo',
	recvGetInvoiceInfoResult: 'recvGetInvoiceInfoResult',
	recvGetInvoiceInfoError: 'recvGetInvoiceInfoError',

	getInvoiceList: 'getInvoiceList',
	beginGetInvoiceList: 'beginGetInvoiceList',
	recvGetInvoiceListResult: 'recvGetInvoiceListResult',
	recvGetInvoiceListError: 'recvGetInvoiceListError',

	failInvoice: 'failInvoice',
	beginFailInvoice: 'beginFailInvoice',
	recvFailInvoiceResult: 'recvFailInvoiceResult',
	recvFailInvoiceError: 'recvFailInvoiceError',


	createInvoice: 'createInvoice',
	beginCreateInvoice: 'beginCreateInvoice',
	recvCreateInvoiceResult: 'recvCreateInvoiceResult',
	recvCreateInvoiceError: 'recvCreateInvoiceError',	


	updateInvoice: 'updateInvoice',
	beginUpdateInvoice: 'beginUpdateInvoice',
	recvUpdateInvoiceResult: 'recvUpdateInvoiceResult',
	recvUpdateInvoiceError: 'recvUpdateInvoiceError',	

	openDownloadTaxMediaDialog: 'openDownloadTaxMediaDialog',
	closeDownloadTaxMediaDialog: 'closeDownloadTaxMediaDialog',
	finishUpdateInvoiceStatus: 'finishUpdateInvoiceStatus',
	finishGetInvoiceItemYearmonthList: 'finishGetInvoiceItemYearmonthList',


	// Allowance
	getAllowanceInfo: 'getAllowanceInfo',
	beginGetAllowanceInfo: 'beginGetAllowanceInfo',
	recvGetAllowanceInfoResult: 'recvGetAllowanceInfoResult',
	recvGetAllowanceInfoError: 'recvGetAllowanceInfoError',

	getAllowanceList: 'getAllowanceList',
	beginGetAllowanceList: 'beginGetAllowanceList',
	recvGetAllowanceListResult: 'recvGetAllowanceListResult',
	recvGetAllowanceListError: 'recvGetAllowanceListError',


	createAllowance: 'createAllowance',
	beginCreateAllowance: 'beginCreateAllowance',
	recvCreateAllowanceResult: 'recvCreateAllowanceResult',
	recvCreateAllowanceError: 'recvCreateAllowanceError',
	
	uploadAllowanceToTurnkey: 'uploadAllowanceToTurnkey',
	uploadAllowanceToTurnkeyStarted: 'uploadAllowanceToTurnkeyStarted',
	uploadAllowanceToTurnkeySuccess: 'uploadAllowanceToTurnkeySuccess',
	uploadAllowanceToTurnkeyFailed: 'uploadAllowanceToTurnkeyFailed',
	delAllowanceInvoiceSuccess: 'delAllowanceInvoiceSuccess',

	// confirm dialog
    openConfirmDialog: 'openConfirmDialog',
	closeConfirmDialog: 'closeConfirmDialog',
	// alart dialog
    openAlartDialog: 'openAlartDialog',
	closeAlartDialog: 'closeAlartDialog',
	
	// 發票對獎
	getPrizedInvoiceList: 'getPrizedInvoiceList',
	beginGetPrizedInvoiceList: 'beginGetPrizedInvoiceList',
	recvGetPrizedInvoiceListResult: 'recvGetPrizedInvoiceListResult',
	recvGetPrizedInvoiceListError: 'recvGetPrizedInvoiceListError',
	finishGetInvoicePrizeYearmonthList: 'finishGetInvoicePrizeYearmonthList',

	checkPrizedInvoice: 'checkPrizedInvoice',
	beginCheckPrizedInvoice: 'beginCheckPrizedInvoice',
	recvCheckPrizedInvoiceResult: 'recvCheckPrizedInvoiceResult',
	recvCheckPrizedInvoiceError: 'recvCheckPrizedInvoiceError',	
		
	// TurnkeyUploadLog	
	beginGetTurnkeyUploadLogList: 'beginGetTurnkeyUploadLogList',
	recvGetTurnkeyUploadLogListResult: 'recvGetTurnkeyUploadLogListResult',
	recvGetTurnkeyUploadLogListError	: 'recvGetTurnkeyUploadLogListError',
	finishGetTurnkeyUploadLogYearmonthList: 'finishGetTurnkeyUploadLogYearmonthList',
};



// WEBPACK FOOTER //
// ./src/actions/webActionTypes.js